module.exports = __webpack_public_path__ + "img/codemig.de0bbb6f.png";